module.exports = __webpack_public_path__ + "img/3.41c93057.jpg";